import React, { useMemo, useState, useEffect } from 'react';

const ResultsScreen = ({ results = [], selectedGrade, alphabetResults }) => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const summary = useMemo(() => {
    if (!results || results.length === 0) return null;
    const last = results[results.length - 1];
    const best = results.reduce((acc, r) => (r.accuracyAvg > acc.accuracyAvg ? r : acc), results[0]);
    return { last, best };
  }, [results]);

  // Play parentEmail audio when component loads with 1 second delay
  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        const audio = new Audio(process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/audio/ParentsEmail.mp3` : '/audio/ParentsEmail.mp3');
        audio.play().catch(() => { });
      } catch { }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmed)) {
      alert('Please enter a valid email address.');
      return;
    }

    const last = results && results.length ? results[results.length - 1] : null;

    const convertGradeForEmail = (grade) => {
      return grade === 'HS' ? 9 : grade;
    };

    const payload = {
      email: trimmed,
      selectedGrade: convertGradeForEmail(selectedGrade ?? null),
      // Last attempt fields
      // last: last ? {
      //   grade: last.grade,
      //   attempt: last.attempt,
      //   matchedWords: last.matched,
      //   totalWords: last.total,
      //   passWords: last.passWords,
      //   pass: !!last.pass,
      //   accuracy: Math.round(last.accuracyAvg || 0),
      //   wcpm: last.wcpm ? Math.round(last.wcpm) : null,
      // } : null,
      // All attempts summary (optional)
      // attempts: (results || []).map((r, i) => ({
      //   idx: i + 1,
      //   grade: r.grade,
      //   attempt: r.attempt,
      //   matchedWords: r.matched,
      //   totalWords: r.total,
      //   passWords: r.passWords,
      //   pass: !!r.pass,
      //   accuracy: Math.round(r.accuracyAvg || 0),
      //   wcpm: r.wcpm ? Math.round(r.wcpm) : null,
      // })),
      // lastReadingAccuracy: Math.round(last.accuracyAvg || 0),
      lastReadingGrade: Number(convertGradeForEmail(last.grade)),
      lastReadingPassed: !!last.pass,
      // lastReadingWpm: last.wcpm ? Math.round(last.wcpm) : null,
      pretest: alphabetResults ? Number(alphabetResults.correctCount) : null,
      // timestamp: new Date().toISOString(),
    };

    try {
      const res = await fetch('https://frc.api.read21.org/api/email/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error('Request failed');
      setIsSubmitted(true);
    } catch (err) {
      alert('There was a problem submitting your results. Please try again later.');
    }
  };

  return (
    <div className="content-area">
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        gap: '60px',
        padding: '70px 20px'
      }}>
        {!isSubmitted ? (
          <>
            {/* Success message */}
            <div className="success-message">
              <div className="success-title">
                Good Reading!
              </div>
              {/* Display alphabet pretest results if available */}
              {/* {alphabetResults && (
                <div style={{ 
                  fontFamily: 'var(--font-albert)', 
                  fontSize: '18px',
                  marginTop: '20px',
                  color: 'var(--black)'
                }}>
                  pretest: {alphabetResults.correctCount}
                </div>
              )} */}
              {/* <div className="success-subtitle">
                Show your parent.
              </div>
              {summary && (
                <div style={{ fontFamily: 'var(--font-albert)', fontSize: '16px' }}>
                  <div>
                    Last Attempt: Grade {summary.last.grade}, Accuracy {Math.round(summary.last.accuracyAvg)} / 100, {summary.last.pass ? 'Passed' : 'Not passed'}
                    {typeof summary.last.matched === 'number' && typeof summary.last.passWords === 'number' && (
                      <> — {summary.last.matched} / {summary.last.total ?? '-'} matched (needed {summary.last.passWords})</>
                    )}
                  </div>
                  <div>Best Attempt: Grade {summary.best.grade}, Accuracy {Math.round(summary.best.accuracyAvg)} / 100</div>
                </div>
              )} */}
            </div>

            {/* Email form */}
            <form onSubmit={handleSubmit} className="email-form">
              <div className="form-label">
                Enter your email to receive the results.
              </div>

              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your.email@example.com"
                className="email-input"
                required
              />

              <button
                type="submit"
                className="btn-primary btn-medium"
                style={{ width: '302px' }}
              >
                GET RESULTS
              </button>
            </form>
          </>
        ) : (
          /* Thank you message */
          <div className="success-message">
            <div className="success-title">
              Thank You!
            </div>
            <div className="success-subtitle">
              Check your email for the reading assessment results.
            </div>
            <div style={{
              marginTop: '20px',
              padding: '20px',
              backgroundColor: 'rgba(255, 87, 95, 0.1)',
              borderRadius: '10px',
              textAlign: 'center'
            }}>
              <div style={{
                fontFamily: 'var(--font-albert)',
                fontSize: '16px',
                color: 'var(--black)',
                lineHeight: '1.5'
              }}>
                Your reading assessment has been completed successfully.
                Results and recommendations will be sent to <strong>{email}</strong>.
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResultsScreen;
